import {useMediaQuery} from '@mui/material'

import {theme} from '@root/theme'

type Breakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
type BreakpointsBetween = {start: Breakpoints; end: Breakpoints}

type TypesSingle = 'up' | 'down' | 'only'
type Types = TypesSingle | 'between'

type HookSingle = (type: TypesSingle, breakpoints: Breakpoints) => boolean
type HookBetween = (type: 'between', breakpoints: BreakpointsBetween) => boolean
type Hook = HookSingle & HookBetween

const useResponsive: Hook = (type: Types, breakpoints: any): boolean => {
  let query = ''
  if (type === 'between') {
    const bp = breakpoints as BreakpointsBetween
    query = theme.breakpoints[type](bp.start, bp.end)
  } else {
    query = theme.breakpoints[type](breakpoints as Breakpoints)
  }
  return useMediaQuery(query)
}

export {useResponsive}
